import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=2ecfb6df"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=2ecfb6df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports